import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import AppHeader from "../../components/AppHeader/AppHeader";
import Leaderboard from "../../components/Leaderboard/Leaderboard";
import ApiErrorModal from "../../components/Modals/ApiErrorModal/ApiErrorModal";
import FirstComeModal from "../../components/Modals/FirstComeModal/FirstComeModal";
import MonthlyModal from "../../components/Modals/MonthlyModal/MonthlyModal";
import ScoreboardModal from "../../components/Modals/ScoreboardModal/ScoreboardModal";
import {setModalVisibility} from "../../core/app/setModalVisibility/actions";
import {ModalType} from "../../core/models/custom/enums/modalType";
import {ModalVisibilityPayload} from "../../core/models/custom/modalVisibility.payload";
import {MeDto} from "../../core/models/dtos/me.dto";
import {GetLeaderboardState} from "../../core/services/userService/getLeaderboard/types";
import {Helpers} from "../../core/utilities/helpers";
import {withRouter, WithRouterProps} from "../../core/utilities/hooks";
import {IStore} from "../../core/utilities/reducers";
import {router} from "../../core/utilities/router";
import "./HomePage.scss";

interface IProps {
  me?: MeDto;
  contents: Map<string, string>;
  modalVisibilityData: ModalType[];
  getLeaderboardState: GetLeaderboardState;
  setModalVisibility: (payload: ModalVisibilityPayload) => void;
}

class HomePage extends React.Component<WithRouterProps<IProps>> {
  
  private handleQuestion() {
    this.props.navigate(router.QUESTION);
  }
  
  render() {
    return (
      <div id="home-page" className="page">
        <div className="page-content">
          <div className="authorized">
            <AppHeader/>
            <Leaderboard/>
          </div>
        </div>
        {
          (
            this.props.modalVisibilityData.includes(ModalType.SCOREBOARD) &&
            !Helpers.isFirstComeModal(this.props.me, this.props.getLeaderboardState.data?.rank)
          ) &&
          <ScoreboardModal/>
        }
        {
          (
            this.props.modalVisibilityData.includes(ModalType.MONTHLY) &&
            !Helpers.isFirstComeModal(this.props.me, this.props.getLeaderboardState.data?.rank)
          ) &&
          <MonthlyModal/>
        }
        {
          Helpers.isFirstComeModal(this.props.me, this.props.getLeaderboardState.data?.rank) &&
          <FirstComeModal callback={() => this.handleQuestion()}/>
        }
        <ApiErrorModal/>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setModalVisibility,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
    contents: store.getContents.data,
    modalVisibilityData: store.setModalVisibility.data,
    getLeaderboardState: store.getLeaderboard,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter<IProps>(HomePage));
